import React from 'react'
import { Grid, Stack } from '../layout'
import { Text } from '../Text'

type TCardDetails = {
  expiryDate: string
  lastFourDigits?: string
  cardType: string
}

export const CardDetails = ({ cardDetails }: { cardDetails: TCardDetails }) => (
  <Grid
    templateColumns={{ base: '1fr', md: '1fr 1fr' }}
    data-testid="card-details"
    gap={24}
  >
    <Stack as="dl" spacing={6}>
      <Text variant="body-md-500-caps" as="dt" color="aubergine">
        Card ending in
      </Text>
      <Text variant="body-md" as="dd" data-testid="card-last4" color="pepper">
        {cardDetails.lastFourDigits}
      </Text>
    </Stack>
    <Stack as="dl" spacing={6}>
      <Text variant="body-md-500-caps" as="dt" color="aubergine">
        Card type
      </Text>
      <Text variant="body-md" as="dd" data-testid="card-type" color="pepper">
        {cardDetails.cardType}
      </Text>
    </Stack>
    <Stack as="dl" spacing={6}>
      <Text variant="body-md-500-caps" as="dt" color="aubergine">
        Expires
      </Text>
      <Text variant="body-md" as="dd" data-testid="card-expiry" color="pepper">
        {cardDetails.expiryDate}
      </Text>
    </Stack>
  </Grid>
)
